/* Compatibilidad de códecs: qué decodifica este navegador/WebView de lo que el panel
   informa (ffprobe) sobre un archivo de película o episodio. */

export const CODEC_LABELS = { h264: 'H.264', avc: 'H.264', hevc: 'H.265 (HEVC)', h265: 'H.265 (HEVC)', av1: 'AV1', vp9: 'VP9', mpeg4: 'MPEG-4', mpeg2video: 'MPEG-2', aac: 'AAC', mp3: 'MP3', ac3: 'AC-3 (Dolby)', eac3: 'E-AC-3 (Dolby+)', dts: 'DTS', truehd: 'TrueHD', opus: 'Opus', vorbis: 'Vorbis', flac: 'FLAC', pcm_s16le: 'PCM' };

let probe = null;
function can(type) {
    try {
        if (!probe) probe = document.createElement('video');
        return !!probe.canPlayType(type);
    } catch (e) {
        return false;
    }
}

/** @returns {{video:string, audio:string, videoOk:boolean, audioOk:boolean, known:boolean}} */
export function codecSupport(info) {
    const v = info && info.video ? String(info.video.codec_name || '').toLowerCase() : '';
    const a = info && info.audio ? String(info.audio.codec_name || '').toLowerCase() : '';
    const videoOk = !v || (v === 'h264' || v === 'avc') ? true
        : v === 'hevc' || v === 'h265' ? (can('video/mp4; codecs="hvc1.1.6.L93.B0"') || can('video/mp4; codecs="hev1.1.6.L93.B0"'))
            : v === 'av1' ? can('video/mp4; codecs="av01.0.05M.08"')
                : v === 'vp9' ? can('video/webm; codecs="vp9"')
                    : true;
    const audioOk = !a || (a === 'aac' || a === 'mp3' || a === 'opus' || a === 'vorbis' || a === 'flac' || a.indexOf('pcm') === 0) ? true
        : a === 'ac3' ? can('audio/mp4; codecs="ac-3"')
            : a === 'eac3' ? can('audio/mp4; codecs="ec-3"')
                : a === 'dts' || a === 'truehd' ? false
                    : true;
    return { video: v, audio: a, videoOk, audioOk, known: !!(v || a) };
}
